<template>
  <div class="vertify-code-container">
    <input
      v-model="code"
      type="number"
      class="vertify-code-input"
      placeholder="请输入验证码"
      maxlength="6"
      @input="onInputCode"
    />
    <div
      v-if="countDown > 0"
      class="tip-text"
    >
      {{ countDown }}秒后重新获取
    </div>
    <div
      v-if="countDown <= 0"
      class="tip-text try-again-button"
      @click="sendMessage"
    >
      重新获取验证码
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AgreementApi from '@/api/agreement';
import { transformNumberToStr } from '@/util/filter';
import STATUS from '@/constants/status';

const COUNTDOWN_SECONDS = 60;

export default {
  name: 'InputField',
  data() {
    return {
      code: '',
      countDown: COUNTDOWN_SECONDS,
      timer: null,
    };
  },
  computed: {
    ...mapGetters('partnerModule', ['id', 'agreementOnShowDescriptions']),
  },
  methods: {
    async sendMessage() {
      /*
       *  根据当前协议选择对应的发送短信方法
       *  在@/api/agreement 中添加方法
       *  在@/constants/agreement AGREEMENT_TYPE_DESC中sendMessageApiName字段维护/添加对应协议发送短信的方法
       */
      try {
        const sendMessageApiMethod = AgreementApi[this.agreementOnShowDescriptions.sendMessageApiName];
        const { respCode, code } = await sendMessageApiMethod({
          partnerId: this.id.toString(),
        }) || {};
        const _responseCode = transformNumberToStr(respCode) || transformNumberToStr(code);

        if (Number(_responseCode) === STATUS.SUCCESS) {
          this.$dialog.toast('已发送', {
            type: 'success',
            className: 'agreement-toast center',
          });
        } else {
          this.$dialog.toast('发送失败', {
            type: 'fail',
            className: 'agreement-toast center',
          });
        }

        this.startTimer();
      } catch (e) {
        console.log(e);
        console.error(`AgreementApi中 ${this.agreementOnShowDescriptions.sendMessageApiName} api可能不存在`);
      }
    },

    startTimer() {
      this.countDown = COUNTDOWN_SECONDS;
      this.timer = setInterval(() => {
        this.countDown = this.countDown - 1;
        if (this.countDown < 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },

    onInputCode() {
      this.$emit('input-code', this.code);
    },

    clearInput() {
      this.code = '';
    },
  },
};
</script>

<style lang="scss" scoped>
$grey1: #ccc;
$grey2: #666;
$yellow1: #FFC700;
$yellow2: #FE8C00;

.vertify-code-container {
  border: 1px solid $grey1;
  width: 100%;
  padding: 0.23rem 0.24rem;
  display: flex;

  .vertify-code-input {
    width: calc(100% - 1.92rem);
    caret-color: $yellow1;
    margin-right: 0.15rem;
  }

  .tip-text {
    font-size: 0.24rem;
    color: $grey2;
    width: 1.77rem;

    &.try-again-button {
      color: $yellow2;
    }
  }
}
</style>
